import { PureComponent } from "react";
import GridParagraphWithImage from "segments/desktop/core-components/grid-paragraph-with-image/grid-paragraph-with-image";
import { componentStyles } from "./flexible-cards-grid-desktop-component.scss";
import FlexibleCardsGridDefaultProps from "../default-props";
import { COLUMN_WIDTH, MARGIN_BETWEEN_CARDS } from "../../flexible-cards-consts";

const IMAGE_HEIGHT = "100%";
const IMAGE_WIDTH = "100%";
const margin = `${MARGIN_BETWEEN_CARDS / 2}px`;

export default class FlexibleCardsGridDesktopComponent extends PureComponent {
  renderGridItems() {
    const { shadowCards, gridItems, titleSize, textSize } = this.props;

    return gridItems.map((gridItem, index) => {
      const { textColor, cardColor, cardNumOfColumnsWidth, fullParagraph, ...resImageProps } = gridItem;
      const columnWidthForCss = `${COLUMN_WIDTH}px`;
      let cardWidthForCss;
      if (cardNumOfColumnsWidth) {
        const cardWidth = cardNumOfColumnsWidth * COLUMN_WIDTH + (cardNumOfColumnsWidth - 1) * MARGIN_BETWEEN_CARDS;
        cardWidthForCss = `${cardWidth}px`;
      }

      return (
        <div
          key={index}
          className="grid-paragraph-with-image-component-wrapper"
          style={{ "--flexible-grid-card-width": cardWidthForCss || columnWidthForCss, "--cards-margin": margin }}
        >
          <GridParagraphWithImage
            {...resImageProps}
            fullParagraph={fullParagraph}
            width={IMAGE_WIDTH}
            height={IMAGE_HEIGHT}
            titleSize={titleSize}
            textSize={textSize}
            cardColor={cardColor}
            textColor={textColor}
            shadowCards={shadowCards}
            cardWidthForCss={cardWidthForCss}
          />
        </div>
      );
    });
  }

  render() {
    return (
      <div className="flexible-cards-grid-desktop-component">
        {this.renderGridItems()}

        <style jsx>{componentStyles}</style>
      </div>
    );
  }
}

FlexibleCardsGridDesktopComponent.defaultProps = FlexibleCardsGridDefaultProps;
